import { Email } from '@csp/csp-common-model';
import { ContactPointInV1, ContactPointSystemType } from '@csp/dmdp-api-user-dto';

const toContactPointInV1 = (system: ContactPointSystemType, value: string, primary?: boolean): ContactPointInV1 => ({
  system,
  value: system === ContactPointSystemType.EMAIL ? Email.fromUserInput(value).address : value,
  primary,
});

export const ContactPointInMapper = {
  toContactPointInV1,
};
